import React from 'react';
import { Link } from 'react-router-dom';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import ProductImportsApi from '../../../../services/api/ProductImportsApi';
import ButtonComponent from '../../../../components/common/forms/Button/ButtonComponent';

export default function DataOperations(): JSX.Element {
  const onImportMatching = async () => {
    await ProductImportsApi.importMatchingSheet();
  };

  return (
    <WhitePad>
      <h2>Data Operations</h2>
      <ul>
        <li>
          <Link to="/products/imports/match">Chocolate</Link>
        </li>
        <li>
          <Link to="/products/imports/upload">Logistics</Link>
        </li>
        <li>
          <Link to="/products/import-sizes/upload">Product Sizes</Link>
        </li>
        <li>
          <Link to="/products/import-supplier-data/upload">Supplier Data</Link>
        </li>
        {/* <li>
          <ButtonComponent onClick={onImportMatching} variant="link" title="Import Chocolate Matching" />
        </li>
        <li>
          <Link to="/products/imports/match">Match Chocolate To Current</Link>
          &nbsp;/&nbsp;
          <Link to="/products/imports/display-matches">View</Link>
        </li> */}

        <li>
          <Link to="/products/products/packings">Analize Packings</Link>
        </li>
        <li>
          <Link to="/products/analysis">Analize Products</Link>
        </li>
      </ul>
      <h4>Movements</h4>
      <ul>
        <li>
          <Link to="/inventory/import-export">Import/Export Inventories</Link>
        </li>
      </ul>
      <h4>Fnb</h4>
      <ul>
        <li>
          <Link to="/fnb/products-no-match">Mismatches</Link>
        </li>
        <li>
          <Link to="/fnb/fnb-hanging">Hanging Orders And Quantities</Link>
        </li>
        <li>
          <Link to="/fnb/fnb-problematic-consolidations">Problematic Consolidations</Link>
        </li>
      </ul>
      <h4>Settings</h4>
      <ul>
        <li>
          <Link to="/settings">All Settings</Link>
        </li>
      </ul>
      <h4>Temp</h4>
      <ul>
        <li>
          <Link to="/inventory/migrate-remove">Migrate Remove</Link>
        </li>
      </ul>
    </WhitePad>
  );
}
